import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ListTemplateChaptersForDownload } from "it/primatoo/openapi/api/org/schemas/template/ListTemplateChaptersForDownload";
import {Chapter} from 'it/primatoo/openapi/api/org/schemas/template/_listtemplatechaptersfordownload/Chapter';
import {ChapterStatus} from "it/primatoo/openapi/api/org/schemas/common/docs/ChapterStatus";
import {ListTemplateChapterResponse} from "it/primatoo/openapi/api/org/schemas/common/docs/ListTemplateChapterResponse";

// TODO @GEG componente sbagliato da verificare


@Component({
  selector: 'pt-select-chapter-dialog',
  template: `
    <div class='modal-header'
         (click)='$event.stopPropagation()'>
      <h4 class='modal-title'>
        {{ title | translate }}
      </h4>
    </div>

    <div class='modal-body' (click)='$event.stopPropagation()'>
      <p [innerHTML]="description | translate"></p>
      <ng-container *ngFor="let c of selectedChapter">
        <div class='form-check'>
          <input
            class='form-check-input'
            [disabled]="c.currentStatus === NOT_STARTED"
            [(ngModel)]="c.selected"
            type='checkbox'
            value=''
            [id]='c.id'>
          <label
            class='form-check-label'
            [for]='c.id'>
            {{ c.name }} <span class="fst-italic" *ngIf="c.currentStatus">({{ 'ENUMS.EDITOR_STATE.' + c.currentStatus | translate }})</span>
          </label>
        </div>
      </ng-container>
    </div>

    <div class='modal-footer' (click)='$event.stopPropagation()'>
      <button type='button' class='btn btn-primary btn-sm'
              (click)='confirmAction(); $event.stopPropagation()'>
        <ng-container>
          {{ 'BUTTON.CONFIRM' | translate }}
        </ng-container>
      </button>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `,
})
export class SelectChapterDialogComponent {
  @Input() docId: number;
  @Input() title = 'TITLE.DOWNLOAD_SELECT_CHAPTER';
  @Input() description = 'MESSAGE.DOWNLOAD_SELECT_CHAPTER';
  public selectedChapter: ExChapter[] = [];

  NOT_STARTED = ChapterStatus.NOT_STARTED;

  constructor(public activeModal: NgbActiveModal) {
  }

  public run(listTemplateChaptersForDownload: ListTemplateChaptersForDownload | ListTemplateChapterResponse) {
    this.selectedChapter = [];
    listTemplateChaptersForDownload?.chapters?.forEach((c: Chapter, id: number) => {
      this.selectedChapter.push({
          selector: c.selector,
          name: c.name,
          id,
          currentStatus: (c as any).currentStatus,
          selected: (c as any).currentStatus !== ChapterStatus.NOT_STARTED,
        }
      );
    })
    if (this.selectedChapter?.length <= 1) {
      this.confirmAction();
    }
  }

  confirmAction() {
    const response: Chapter[] = this.selectedChapter.filter(s => s.selected).map(s => {
      const chapter: Chapter = {
        selector: s.selector,
        name: s.name
      }
      return chapter
    })
    this.activeModal.close(response)
  }

}

interface ExChapter extends Chapter {
  id: number;
  selected: boolean;
  currentStatus?: ChapterStatus;
}

